import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Loader2, MessageCircle, Home } from "lucide-react";

export default function RentalSuccess() {
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const [b, setB] = useState(null);
  useEffect(() => {
    if (!sid) return;
    let alive = true, tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/rentals/checkout/status/${sid}`);
        if (!alive) return;
        setB(data);
        if (data.payment_status !== "paid" && tries < 6) { tries++; setTimeout(poll, 1500); }
      } catch { /* */ }
    };
    poll();
    return () => { alive = false; };
  }, [sid]);
  return (
    <div className="max-w-md mx-auto px-6 py-20 text-center" data-testid="rental-success-page">
      <div className="h-16 w-16 mx-auto rounded-full bg-[#0A0A0A] text-white flex items-center justify-center">
        {b?.payment_status === "paid" ? <CheckCircle2 size={26}/> : <Loader2 size={22} className="animate-spin"/>}
      </div>
      <h1 className="font-heading text-3xl mt-5">
        {b?.payment_status === "paid" ? "Rental confirmed." : "Confirming payment…"}
      </h1>
      {b?.payment_status === "paid" && (
        <>
          <p className="text-[#4A4A4A] mt-3">
            <strong>{b.listing_title}</strong> · {b.units} {b.unit}{b.units===1?"":"s"}. Message the owner to coordinate handoff.
          </p>
          <div className="flex flex-col gap-2 mt-6">
            <Link to={`/messages/${b.owner_id}`} className="btn-primary justify-center" data-testid="rental-success-message"><MessageCircle size={14}/> Message the owner</Link>
            <Link to="/rentals" className="btn-ghost justify-center"><Home size={14}/> Browse more rentals</Link>
          </div>
        </>
      )}
    </div>
  );
}
